import Async from "../../components/Async";

// LP do Pulso (F181): pública, para o link que o comercial manda antes da ligação e o "Ver como funciona" do card.
const PulsoLanding = Async(() => import('../../pages/pulso/pulso.landing'));

const externalRoutes = {
    pulsoLanding: {
        id: 'pulsoLanding',
        path: '/pulso',
        component: PulsoLanding,
    },
}

const externalPages = Object.values(externalRoutes);

export default {
    externalRoutes,
    externalPages
}
